import React, { useState, useEffect, useRef } from "react";
import MiloStartScreen from "../components/MiloStartScreen";
import MiloApplicationForm from "../components/MiloApplicationForm";
import MiloDemo from "../components/MiloDemo";
import WaitlistContainer from "../components/MiloWaitlistForm";
import styles from "../styles/MiloApplication.module.css";
import DemoMap from "./DemoMap";

const MiloApplication = ({ step, setStep }) => {
  const [submitted, setSubmitted] = useState(false);
  const [showMap, setShowMap] = useState(false);
  const [typedName, setTypedName] = useState("");
  const [typedEmail, setTypedEmail] = useState("");
  const [approvals, setApprovals] = useState([]);
  const [showFinalApproval, setShowFinalApproval] = useState(false);
  const [shared, setShared] = useState(false); // New state for sharing screen
  const [referralLink, setReferralLink] = useState(""); // Custom referral link
  const fullName = "Jane Doe";
  const fullEmail = "jane@example.com";
  const approvalList = [
    "Fenway Field Apartments - Approved ✅",
    "100 Summer St Apartments - Approved ✅",
    "Cambridge Landing - Approved ✅",
    "More coming soon..."
  ];
  
    // Use a ref to store timeouts so that they persist across renders
  const timeoutsRef = useRef([]);
  // Use a ref to ensure the effect runs only once (helps with Strict Mode double-invocation)
  const effectRan = useRef(false);

  useEffect(() => {
    if (step === 1){

    setTypedName(""); // Reset name
    setTypedEmail(""); // Reset email
    timeoutsRef.current.forEach(clearTimeout); // Clear old timeouts
    timeoutsRef.current = []; // Reset timeout array

    // Function to type the name letter by letter
    const typeNextLetter = (index) => {
      if (index < fullName.length) {
        const timeout = setTimeout(() => {
          setTypedName((prev) => prev + fullName[index]); // Update typed name correctly
          typeNextLetter(index + 1); // Call function with updated index
        }, 200);
        timeoutsRef.current.push(timeout);
      } else {
        timeoutsRef.current.push(setTimeout(() => typeNextEmail(0), 500));
      }
    };

    // Function to type the email after name is completed
    const typeNextEmail = (index) => {
      if (index < fullEmail.length) {
        const timeout = setTimeout(() => {
          setTypedEmail((prev) => prev + fullEmail[index]);
          typeNextEmail(index + 1);
        }, 200);
        timeoutsRef.current.push(timeout);
      }
    };

    typeNextLetter(0); // Start typing name from index 0
	}
	
	if (step === 2) {
      setApprovals([]);
      approvalList.forEach((approval, i) => {
        setTimeout(() => {
          setApprovals((prev) => [...prev, approval]);
          if (i === approvalList.length - 1) setShowFinalApproval(true);
        }, i * 1000);
      });
    }

    return () => {
      timeoutsRef.current.forEach(clearTimeout); // Cleanup pending timeouts
      timeoutsRef.current = []; // Reset array to prevent memory leaks
    };
  }, [step]); // Effect triggers when `step` changes	  
	  
  return (
		<div className={styles["milo-app-wrapper"]}>
		 {step === 0 && <MiloStartScreen setStep={setStep} />}
		 {step === 1 && <MiloApplicationForm setStep={setStep} />}
		 {step === 2 && <MiloDemo setStep={setStep} />}
		 {step === 3 && <DemoMap variant="milo" setStep={setStep} />} 
		 {step === 4 && <WaitlistContainer setStep={setStep} />}
		</div>
  );
};

export default MiloApplication;